import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { isConfigFlagEnabled } from '../../../../config';
import { useAppSelector } from '../../../../redux/store';
import { isTestEnvironment } from '../../../../utils/utils';
import { PixiAutoCheckButton } from './pixiAutoCheckButton';
import { PixiAutoFoldAnyButton } from './pixiAutoFoldAnyButton';
const PIXI_DATA = isTestEnvironment() ? { type: 'auto-bet-controls' } : null;
export const PixiAutoBetControls = () => {
    const availableAutoBetActions = useAppSelector((state) => state.poker.autoBetProperties?.availableAutoBetActions, shallowEqual);
    const autoCheckButtonBounds = useAppSelector((state) => state.gameDimensions.autoCheckButtonBounds, shallowEqual);
    const autoFoldAnyButtonBounds = useAppSelector((state) => state.gameDimensions.autoFoldAnyButtonBounds, shallowEqual);
    if (isConfigFlagEnabled('domBetButtons')) {
        return null;
    }
    if (!availableAutoBetActions) {
        return null;
    }
    const canCheck = availableAutoBetActions.includes('check');
    const canFold = availableAutoBetActions.includes('fold');
    return (_jsxs(Container, { "pixi-data": PIXI_DATA, x: 0, y: 0, children: [canCheck && autoCheckButtonBounds && _jsx(PixiAutoCheckButton, { bounds: autoCheckButtonBounds }), (canCheck || canFold) && autoFoldAnyButtonBounds && _jsx(PixiAutoFoldAnyButton, { bounds: autoFoldAnyButtonBounds })] }));
};
